module.exports = {"203":56,"205":130,"291":38,"301":1,"303":0.008,"304":0.4,"305":0.7,"306":4.7,"307":1.5,"309":0.011,"313":0.004,"315":0.0023,"317":0.000055,"320":0.55,"323":0.015,"328":0.000015,"401":0.09,"404":0.0012,"405":0.0013,"406":0.016,"410":0.005,"415":0.0013,"418":0.0000024,"430":0.00012,"435":0.0004,"851":1.6}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/preprocessed_data/DRI.json
// module id = 835
// module chunks = 3